import React, { useEffect, useState } from 'react'
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { useDispatch, useSelector } from "react-redux";
import { addAssignment, updateAssignment } from '../actions/assignmentsActions';


export const CreateAssigment = ({ closePopup, assignment }) => {

    const subjectInstanceSelected = useSelector((state) =>
        state.selection.selectedSubjectInstance ? state.selection.selectedSubjectInstance : null);
    const subjectInstancesArray = useSelector((state) =>
        state.subjectInstances ? state.subjectInstances : null);
        
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [subject, setSubject] = useState(subjectInstanceSelected);
    const dispatch = useDispatch();

    useEffect(() => {
        if (assignment) {
            setName(assignment.name);
            setDescription(assignment.description);
            setDueDate(assignment.dueDate);
        }
    }, [])


    const handleSubjectChange = (e) => {
        const subjectInstanceId = e.target.value
        const subject = subjectInstancesArray.find(si => si._id == subjectInstanceId);
        setSubject(subject)
    }

    const handleSave = async () => {
        const input = {
            name,
            description,
            dueDate: dueDate? new Date(dueDate).toISOString(): null,
        };
        if (assignment) {
            //is edition
            dispatch(updateAssignment({ ...input, assignmentId: assignment._id }));
        } else {
            //is creation
            dispatch(addAssignment({ ...input, subjectInstanceId: subject._id }));
        }
    };
    return (
        <FormWrapper>
            <Label>
                Subject:
                <Select
                    value={subject?._id}
                    onChange={(e) => { handleSubjectChange(e) }}
                    disabled={!!assignment}
                >
                    {subjectInstancesArray && subjectInstancesArray.map((item, index) => (
                        <option key={index} value={item._id}>{item.subject.name}</option>
                    ))}
                </Select>
            </Label>
            <Label>
                Title:
                <Input
                    type="text"
                    name="title"
                    value={name}
                    onChange={(e) => { setName(e.target.value) }}
                />
            </Label>
            <Label>
                Description:
                <Input
                    type="text"
                    name="description"
                    value={description}
                    onChange={(e) => { setDescription(e.target.value) }}
                />
            </Label>
            <Label>
                Due date:
                <Input
                    type="date"
                    name="dueDate"
                    placeholder='Due date'
                    value={dueDate?.split('T')[0]}
                    onChange={(e) => { setDueDate(e.target.value); }}
                />
            </Label>
            <Button onClick={() => handleSave()}>Save</Button>
        </FormWrapper>
    );
};


export default CreateAssigment;
